import { MarkdownDocPage } from "@/components/MarkdownDocPage";
import { createFileRoute } from "@tanstack/react-router";
import phase1Md from "../../../docs/phase1.md?raw";

export const Route = createFileRoute("/docs/phase1/")({
	component: () => <MarkdownDocPage source={phase1Md} />,
});
